import React, { useState } from "react";
import Header from "../common/Header";
import Aside from "../common/Asside";

function Member() {
  const [dateFilterVisible, setDateFilterVisible] = useState(false);
  const [results, setResults] = useState([]);
  const [pagination, setPagination] = useState({ currentPage: 1, totalPages: 0 });

  const [filters, setFilters] = useState({
    startTime: "",
    endTime: "",
    username: "",
    lastBetTimeSince: "",
    lastDepositSince: "",
  });
  const formatDate = (date) => {
    return new Date(date).toLocaleString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };
  
  const handleSearch = async () => {
    try {
      const response = await fetch("https://esgaming.online/api/member-search", {
        method: "POST",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(filters),
      });

      if (!response.ok) throw new Error("Network response was not ok");

      const data = await response.json();
      setResults(data); // Set search results to state
      setPagination({ currentPage: 1, totalPages: Math.ceil(data.length / 10) }); // Adjust pagination as necessary
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const toggleDateFilter = () => setDateFilterVisible(!dateFilterVisible);

  return (
    <div>
      <Header />
      <div className="container-flex">
        <Aside />
        <div className="main">
          <div className="page-content">
            <div className="main-inner">
              <div className="page-content-body" style={{ display: "block" }}>
                <form id="memberSearchForm">
                  <div className="section">
                    <div className="section-head">
                      <h2 className="title">Member Search</h2>
                    </div>
                    <div className="section-body">
                      {/* Date Filter */}
                      <div className="filter" id="dateFilter">
                        <button
                          type="button"
                          className="btn-primary btn-dropdown dropdown-toggle"
                          onClick={toggleDateFilter}
                        >
                          Date Filter
                        </button>
                        <div className={`dropdown-menu filter-group ${dateFilterVisible ? "d-block" : "d-none"}`}>
                          <dl className="filter-item">
                            <dt className="filter-head" />
                            <dd>
                              <div className="form-group">
                                <div className="btn-group">
                                  {/* Date Filter Buttons */}
                                  <button type="button" className="btn-secondary dateFilterBtn" onClick={() => setFilters({ ...filters, startTime: "2024-11-04", endTime: "2024-11-04" })}>Today</button>
                                  <button type="button" className="btn-secondary dateFilterBtn" onClick={() => setFilters({ ...filters, startTime: "2024-11-03", endTime: "2024-11-03" })}>Yesterday</button>
                                  {/* Add other date range options as required */}
                                </div>
                              </div>
                            </dd>
                          </dl>
                          <div className="filter-foot">
                            <button type="button" className="btn-light" onClick={toggleDateFilter}>Cancel</button>
                          </div>
                        </div>
                      </div>

                      {/* Form Filters */}
                      <div className="d-flex">
                        <div className="form-group form-column form-2-col">
                          <label className="label bold">Registered Date Range</label>
                          <input
                            type="date"
                            className="form-control"
                            name="startTime"
                            value={filters.startTime}
                            onChange={(e) => setFilters({ ...filters, startTime: e.target.value })}
                          />
                        </div>
                        <div className="form-group form-column form-2-col">
                          <label className="label bold">&nbsp;</label>
                          <input
                            type="date"
                            className="form-control"
                            name="endTime"
                            value={filters.endTime}
                            onChange={(e) => setFilters({ ...filters, endTime: e.target.value })}
                          />
                        </div>
                      </div>
                      <div className="d-flex">
                        <div className="form-group form-column form-2-col">
                          <label className="label bold">Username</label>
                          <input
                            className="form-control"
                            name="username"
                            value={filters.username}
                            onChange={(e) => setFilters({ ...filters, username: e.target.value })}
                          />
                        </div>
                      </div>
                      <div className="d-flex">
                        <div className="form-group form-column form-2-col">
                          <label className="label bold">Last Bet Time Since</label>
                          <input
                            type="date"
                            className="form-control"
                            name="lastBetTimeSince"
                            value={filters.lastBetTimeSince}
                            onChange={(e) => setFilters({ ...filters, lastBetTimeSince: e.target.value })}
                          />
                        </div>
                        <div className="form-group form-column form-2-col">
                          <label className="label bold">Last Deposit Since</label>
                          <input
                            type="date"
                            className="form-control"
                            name="lastDepositSince"
                            value={filters.lastDepositSince}
                            onChange={(e) => setFilters({ ...filters, lastDepositSince: e.target.value })}
                          />
                        </div>
                      </div>

                      {/* Table for Results */}
                      <div className="table-wrap" style={{ marginTop: "20px" }}>
                        <table className="table dataTable">
                          <thead>
                            <tr>
                              <th>Registered Time</th>
                              <th>Username</th>
                              <th>Last Deposit</th>
                              <th>Last Bet Time</th>
                              <th>Currency Type</th>
                            </tr>
                          </thead>
                          <tbody>
                            {results.length === 0 ? (
                              <tr>
                                <td colSpan="5" className="text-center">No data available</td>
                              </tr>
                            ) : (
                              results.map((result, index) => (
                                <tr key={index}>
                                  <td>{formatDate(result.registered_time || "N/A")}</td>
                                  <td>
                                    {(() => {
                                      const username = result.username || '';
                                      const visibleChars = 3;
                                      const masked = '*'.repeat(Math.max(0, username.length - visibleChars));
                                      const visible = username.slice(-visibleChars);
                                      return masked + visible;
                                    })()}
                                  </td>


                                  <td>{formatDate(result.last_deposit_time || "N/A")}</td>
                                  <td>{formatDate(result.last_bet_time || "N/A")}</td>
                                  <td>BDT</td>
                                </tr>
                              ))
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>

                    <div className="section-foot">
                      <div className="btn-group float-right">
                        <button type="button" className="btn-primary" onClick={handleSearch}>
                          <span className="ic-search" /> <span className="text">Search</span>
                        </button>
                      </div>
                      <div className="btn-group float-right">
                        <button type="button" className="btn-primary">
                          <span className="ic-excel" /> <span className="text">Export</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <footer className="footer">Copyright © 2020. All rights Reserved</footer>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Member;
